import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import Axios from 'axios';
import * as ACData from 'adaptivecards-templating';
import { URL_API } from '../constants';
import { getHeaders, getUrlParam } from '../utils';
import { store } from '../redux/store';

const fetcher = ({ url }) =>
  Axios({
    method: 'GET',
    url: `${URL_API}/api/${url}`,
    headers: getHeaders(store.getState)
  }).then(res => res.data[0].template);

const useCardTemplate = ({ payload }) => {
  const templateUrl = payload?.meta.template_path;
  const queryKey = getUrlParam('hash', templateUrl?.split('?')[1]) || templateUrl;
  const [cardRender, setCardRender] = useState(null);
  const { data } = useQuery([queryKey], () => fetcher({ url: templateUrl }), {
    enabled: !!templateUrl
  });

  useEffect(() => {
    if (data && payload) {
      const templateRender = new ACData.Template(data);

      setCardRender(templateRender.expand({ $root: payload }));
    } else {
      setCardRender(null);
    }
  }, [data]);

  return { cardRender };
};

export default useCardTemplate;
